// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"371":"65fd8607","560":"b6a771db","920":"9792d255"}[chunkId] + ".chunk.css";
};